export default __webpack_public_path__ + "static/media/19-04-23-banner-farm-desktop.d38d9101.jpg";